import React from 'react';
import { Link } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
// import Registration from 'components/authentication/simple/Registration';
// import ThemeControlDropdown from 'components/navbar/top/ThemeControlDropdown';

const LandingRightSideNavItem = () => {
  // const [showRegistrationModal, setShowRegistrationModal] = useState(false);

  return (
    <Nav navbar className="ms-auto align-items-lg-center">
      {/* <Nav.Item as={'li'} className="me-2 d-none d-lg-block">
        <ThemeControlDropdown iconClassName="fs-10" />
      </Nav.Item> */}

      <Nav.Item>
        <Nav.Link as={Link} to="/login" className="nav-link fw-semibold">
          <i className="fas fa-sign-in-alt me-1"></i>Login
        </Nav.Link>
      </Nav.Item>
    </Nav>
  );
};

export default LandingRightSideNavItem;
